import { getQueryStringParameter } from 'owa-querystring';

const AUTOMATION_TYPES = ['OwaPlaywright', 'PAS', 'CFIX', 'CIP'] as const;
export type AutomationType = (typeof AUTOMATION_TYPES)[number];

function isAutomationType(value: string | null | undefined): value is AutomationType {
    return !!value && (AUTOMATION_TYPES as readonly string[]).includes(value);
}

export default function getAutomationType(): AutomationType | undefined {
    const value = getQueryStringParameter('automation');
    return isAutomationType(value) ? value : undefined;
}
